export default "__VITE_ASSET__DGjTh8mY__"